import { Box, Typography } from "@mui/material";
import { TrainingRelationshipSelectorOrderBy } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React from "react";
import { useTranslation } from "react-i18next";
import { BaseTrainingSelectorDrawer, TrainingSelectorFilterOptions, TrainingSelectorProps } from "views/lms/training/drawers/BaseTrainingSelectorDrawer";

////////////////////////////////////////////////////////////////////////////////

interface IProps extends TrainingSelectorProps {
    exceptTrainingId?: string;
}

////////////////////////////////////////////////////////////////////////////////

export const TrainingRelationshipSelectorDrawer: React.FC<IProps> = (props) => {
    const api = useCoreApi();
    const { t } = useTranslation("lms");
    const { exceptTrainingId, trainingType } = props;

    const handleGetdata = ({ signal, ...filter }: TrainingSelectorFilterOptions) => {
        var emptySearch = filter.searchText == "";

        return api.v1.lmsSelectors.trainingRelationship({
            exceptTrainingId: exceptTrainingId ?? null,
            trainingType: trainingType ?? null,
            orderBy: emptySearch ? TrainingRelationshipSelectorOrderBy.MoreRecent : TrainingRelationshipSelectorOrderBy.Title,
            ...filter,
        }, { signal: signal });
    };

    return <BaseTrainingSelectorDrawer
        {...props}
        onGetData={handleGetdata}
        contentHeader={
            (props) => props.searchText == ""
                ? <Box mt={1}><Typography variant="subtitle1">{t("Selectors.Training.ShowingMoreRecent")}</Typography></Box>
                : undefined
        }
    />;
};
